import { createFileRoute } from "@tanstack/react-router";

import { TeleopPage } from "../../../workspaces/fleet/pages/TeleopPage";
import { useSeat } from "../../../workspaces/fleet/seat";

/** The help queue: every robot that asked for a person, for every seat — a teleop vendor's
 * whole job and a Sentient teleoperator's first one. */
export const Route = createFileRoute("/_console/teleoperators/")({
  component: HelpQueue,
});

function HelpQueue() {
  return <TeleopPage user={useSeat()} />;
}
